<template>
  <div class="my-personl accpunt-designer">
    <div class="accpunt-designer-main">
      <div class="title">
        <p class="tag-title">
          <Badge status="processing"/>认证设计师
          <Tag color="default" v-if="details.status === 1">认证中</Tag>
          <Tag color="warning" v-if="details.status === 2">认证成功</Tag>
          <Tag color="error" v-if="details.status === 3">被驳回</Tag>
        </p>
        <p v-if="details.status !== 2" class="tib-title">{{details.status === 3 && details.rejectReason ? '驳回理由：' : '温馨提示：'}}</p>
        <p
          v-if="details.status !== 2"
          class="tib-title"
        >{{details.status === 3 && details.rejectReason ? details.rejectReason : '请上传的实景照片与设计方案相对应，以确保案例方案真实有效，尽快通过住逻辑审核。'}}</p>
      </div>
      <div class="item">
        <p class="title">
          作品1
          <span>（必填 至少传1张，最多9张）</span>
        </p>
        <Row :gutter="16" type="flex" justify="start" class="code-row-bg">
          <Col v-for="(item,index) in files1" :key="index">
            <z-panelimg
              :width="80"
              :height="80"
              :del="!judge"
              @delete="deleteHandle1(index)"
              :src="imgBaseUrl + item.key"
            ></z-panelimg>
          </Col>
          <Col>
            <z-upload
              v-show="files1.length < 9"
              v-if="Object.keys(ossKeys).length > 0 && !judge"
              :type="5"
              cover
              multiple
              @success="successHandle1"
              :maxSize="5120"
              :ossKey="ossKeys"
              :progressBar="true"
            >
              <Button type="dashed" ghost>
                <i class="iconfont icon-plus-m"></i>
              </Button>
            </z-upload>
          </Col>
        </Row>
      </div>

      <div class="item">
        <p class="title">
          作品2
          <span>（必填 至少传1张，最多9张）</span>
        </p>
        <Row :gutter="16" type="flex" justify="start" class="code-row-bg">
          <Col v-for="(item,index) in files2" :key="index">
            <z-panelimg
              :width="80"
              :height="80"
              :del="!judge"
              @delete="deleteHandle2(index)"
              :src="imgBaseUrl + item.key"
            ></z-panelimg>
          </Col>
          <Col>
            <z-upload
              v-show="files2.length < 9"
              v-if="Object.keys(ossKeys).length > 0 && !judge"
              :type="5"
              cover
              multiple
              @success="successHandle2"
              :maxSize="5120"
              :ossKey="ossKeys"
              :progressBar="true"
            >
              <Button type="dashed" ghost>
                <i class="iconfont icon-plus-m"></i>
              </Button>
            </z-upload>
          </Col>
        </Row>
      </div>

      <div class="item">
        <p class="title">
          作品3
          <span>（必填 至少传1张，最多9张）</span>
        </p>
        <Row :gutter="16" type="flex" justify="start" class="code-row-bg">
          <Col v-for="(item,index) in files3" :key="index">
            <z-panelimg
              :width="80"
              :height="80"
             :del="!judge"
              @delete="deleteHandle3(index)"
              :src="imgBaseUrl + item.key"
            ></z-panelimg>
          </Col>
          <Col>
            <z-upload
              v-show="files3.length < 9"
              v-if="Object.keys(ossKeys).length > 0 && !judge"
              :type="5"
              cover
              multiple
              @success="successHandle3"
              :maxSize="5120"
              :ossKey="ossKeys"
              :progressBar="true"
            >
              <Button type="dashed" ghost>
                <i class="iconfont icon-plus-m"></i>
              </Button>
            </z-upload>
          </Col>
        </Row>
      </div>

      <div class="item btn-item" v-if="details.status === 3 || !details.status">
        <Row type="flex" justify="center" align="middle">
          <Col span="6">
            <Button type="primary" :loading="loading" @click="submit" long>提交</Button>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../../../../api/index";
export default {
  data() {
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      loading: false,
      details: "",
      ossKeys: {},
      files1: [],
      files2: [],
      files3: []
    };
  },
  computed:{
    judge() {
      if(this.details.status && this.details.status < 3) {
        return true;
      }
      return false
    }
  },
  methods: {
    getOssKey(type) {
      api.files.uploadUrl(type).then(res => {
        this.ossKeys = res;
      });
    },
    successHandle1(file) {
      this.files1.push(file.data[0]);
    },
    successHandle2(file) {
      this.files2.push(file.data[0]);
    },
    successHandle3(file) {
      this.files3.push(file.data[0]);
    },
    deleteHandle1(index) {
      this.files1.splice(index, 1);
    },
    deleteHandle2(index) {
      this.files2.splice(index, 1);
    },
    deleteHandle3(index) {
      this.files3.splice(index, 1);
    },

    /* 请求详情 */
    get_details() {
      api.authNext.designer_detail().then(res => {
        this.details = res;
        if (this.details.works && this.details.works.length > 0) {
          this.files1 = this.details.works[0].workFiles;
          this.files2 = this.details.works[1].workFiles;
          this.files3 = this.details.works[2].workFiles;
        }
      });
    },

    /*  */

    /* 提交 */
    submit() {
      if (!this.regesct()) {
        this.$Message.warning("请按要求上传图片哦！");
        return false;
      }

      this.loading = true;
      let params = {
        channel: "web",
        works: [
          {
            workFiles: this.files1
          },
          {
            workFiles: this.files2
          },
          {
            workFiles: this.files3
          }
        ]
      };
      api.authNext
        .designer(params)
        .then(res => {
          this.$Message.success("设计师认证提交成功，请耐心等待审核！");
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    /* 判断是否已经传图片 */
    regesct() {
      if (
        this.files1.length === 0 ||
        this.files2.length === 0 ||
        this.files3.length === 0
      ) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getOssKey(5);
    this.get_details();
  }
};
</script>
<style lang="scss">
.accpunt-designer {
  .accpunt-designer-main {
    text-align: left;
    width: 880px;
    min-height: 1200px;
    .btn-item {
      margin-top: 50px;
    }
    .title {
      margin-top: -50px;
      margin-bottom: 30px;
      .tag-title {
        font-size: 20px;
        margin-bottom: 20px;
      }
      .tib-title {
        color: #787878;
        font-size: 14px;
      }
    }
    .item {
      .ivu-upload-drag {
        background: #fff;
      }
      .ivu-btn-dashed {
        border: 1px dashed rgba(151, 151, 151, 1);
        border-radius: 4px;
        width: 80px;
        height: 80px;
        i {
          color: rgba(151, 151, 151, 1);
          font-size: 40px;
        }
        &:hover {
          color: rgba(151, 151, 151, 1);
        }
      }
      .ivu-col {
        margin-bottom: 10px;
      }
      .title {
        font-size: 20px;
        margin-bottom: 20px;
        margin-top: 10px;
        span {
          font-size: 12px;
          color: rgba(120, 120, 120, 1);
        }
      }
    }
  }
}
</style>


